module.exports = __webpack_public_path__ + "img/60.d02498a4.png";